
import { axios } from '@/utils/request'
import { sysInfo } from '@/config'

// const sysInfo = {
//   apiRemote: 'http://192.168.2.46:9005'
// }

export function insertSale (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/sale',
    method: 'POST',
    data: parameter
  })
}
export function updateSale (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/sale',
    method: 'PUT',
    data: parameter
  })
}
export function deleteSale (parameter) {
  return axios({
    url: sysInfo.apiRemote + '/contract/sale',
    method: 'DELETE',
    params: parameter
  })
}
export function getSaleList (parameter) {
  return axios({
    url: sysInfo.apiRemote +'/contract/sale',
    method: 'GET',
    params: parameter
  })
}
export function getSaleInfo (parameter) {
return axios({
    url: sysInfo.apiRemote + '/contract/sale/detail',
    method: 'GET',
    params: parameter
  })
}
